import React from 'react';

const TextAlignment = ({ text, error }) => {
  const formattedText = text
    .replace(/- /g, '<li style="margin-left:30px" class="highlight">')
    .replace(/: /g, ':<span style="padding-left:10px;font-weight:normal">')
    .replace(/\n\n/g, '</span></ul><ul style="list-style-type: circle;padding:5px;margin-top:10px;padding-left:0px">')
    .replace(/\n\n-/g, '</li></ul><ul style="list-style-type: none;padding:5px">')
    .replace(/\n/g, '<br/>');

  // Wrap the formattedText in a <ul> to ensure it's a valid HTML structure
  const htmlString = `<ul style="list-style-type: circle; margin-bottom: 0px; padding-left: 0px">${formattedText}</ul>`;

  return (
    <div className={`faqs_items_cls items_cls font-size-new ${error || ''}`}>
      <div dangerouslySetInnerHTML={{ __html: htmlString }}></div>
    </div>
  );
};

export default TextAlignment;
